/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */

export type ExternalCharityTypeRequestCharityType =
  typeof ExternalCharityTypeRequestCharityType[keyof typeof ExternalCharityTypeRequestCharityType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalCharityTypeRequestCharityType = {
  TRUST: 'TRUST',
  UNINCORPORATED_ASSOCIATION: 'UNINCORPORATED_ASSOCIATION',
  CHARITABLE_INCORPORATED_ORGANISATION: 'CHARITABLE_INCORPORATED_ORGANISATION',
  COMPANY_LIMITED_BY_GUARANTEE: 'COMPANY_LIMITED_BY_GUARANTEE',
  OTHER: 'OTHER',
} as const;
